<form [formGroup]="companyForm" (ngSubmit)="submit()">
  <app-section
    title="Cadastro de empresa"
    description="Preencha os dados da sua empresa para começar a emitir notas fiscais."
  >
    <app-fields>
      <div class="cnpj-field">
        <app-input
          class="cnpj-input"
          label="CNPJ"
          formControlName="cpfCnpj"
          mask="00.000.000/0000-00"
          [hint]="
            cnpjLookupLoading()
              ? 'Consultando a Receita Federal…'
              : 'Ao completar o CNPJ, os dados da Receita Federal são preenchidos automaticamente.'
          "
        ></app-input>
        <!-- Consulta é automática ao completar o CNPJ; o ícone só força uma
             nova consulta (ex.: empresa já cadastrada). -->
        <button
          type="button"
          class="cnpj-lookup-button"
          title="Buscar dados na Receita Federal"
          aria-label="Buscar dados na Receita Federal"
          [disabled]="cnpjLookupLoading() || !cnpjCompleto"
          (click)="buscarCnpj()"
        >
          <span
            class="pi"
            [ngClass]="cnpjLookupLoading() ? 'pi-spin pi-spinner' : 'pi-search'"
          ></span>
        </button>
      </div>
      <app-input
        label="Razão social"
        formControlName="razaoSocial"
        [maxlength]="60"
        [hint]="
          razaoSocialExcedeLimite
            ? 'A razão social da Receita tem mais de 60 caracteres: abrevie antes de salvar.'
            : ''
        "
      ></app-input>
      <app-input label="Nome fantasia" formControlName="nomeFantasia">
      </app-input>
      <app-input
        formControlName="inscricaoEstadual"
        label="Inscrição estadual"
      ></app-input>
      <app-input
        formControlName="inscricaoMunicipal"
        label="Inscrição municipal"
      ></app-input>
      <app-input type="email" label="E-mail" formControlName="email">
      </app-input>
      <app-select
        [options]="yesOrNot"
        label="Optante pelo simples nacional"
        formControlName="simplesNacional"
      ></app-select>
      <app-select
        [options]="regimesTributarios"
        formControlName="regimeTributario"
        label="Regime tributário"
      ></app-select>
      <app-select
        [options]="regimesTributariosEspeciais"
        formControlName="regimeTributarioEspecial"
        label="Regime tributário especial"
      ></app-select>
    </app-fields>
    <!-- Resumo da consulta na Receita (nf-server → PlugNotas GET /cnpj). A
         consulta não traz IE, IM nem regime tributário: esses campos seguem
         manuais. -->
    <div class="cnpj-lookup" *ngIf="cnpjLookup() as lookup">
      <h2>Dados da Receita Federal</h2>
      <p>
        <span>Situação cadastral:</span>
        <span class="value" [class.inactive]="!cnpjSituacaoAtiva">
          {{ lookup.situacaoCadastral || "não informada" }}
          <ng-container *ngIf="lookup.dataSituacao">
            (desde {{ lookup.dataSituacao }})
          </ng-container>
        </span>
      </p>
      <p *ngIf="!cnpjSituacaoAtiva" class="warning">
        A Receita não retornou este CNPJ como ATIVO. Confira a situação antes de
        emitir notas: a SEFAZ rejeita emissões de CNPJ inapto ou baixado.
      </p>
      <p *ngIf="cnpjAtividadePrincipal as principal">
        <span>CNAE principal:</span>
        <span class="value">
          {{ principal.codigoFormatado }} - {{ principal.descricao }}
        </span>
      </p>
      <p *ngIf="lookup.naturezaJuridica">
        <span>Natureza jurídica:</span>
        <span class="value">{{ lookup.naturezaJuridica }}</span>
      </p>
      <p *ngIf="lookup.telefone">
        <span>Telefone na Receita:</span>
        <span class="value">{{ lookup.telefone }}</span>
      </p>
      <p class="hint">
        Inscrição estadual, inscrição municipal, Simples Nacional e regime
        tributário não vêm da Receita: confira e preencha manualmente.
      </p>
    </div>
  </app-section>
  <app-section
    *ngIf="cnpjLookup() && ncmsSugeridos.length"
    title="NCMs sugeridos pelo CNAE"
    description="Sugestões a partir das atividades (CNAE) da empresa na Receita Federal. Importar cria o NCM como rascunho, só com o código: os tributos (origem, CST/CSOSN, PIS/COFINS, IBS/CBS) são preenchidos depois na aba NF-e e a emissão fica bloqueada até lá. Confirme a classificação com o seu contador."
  >
    <p class="suggestions-hint" *ngIf="!produtoAtivo">
      Habilite a emissão de NF-e ou NFC-e e salve o cadastro para importar ou
      parametrizar NCMs.
    </p>
    <p class="suggestions-hint" *ngIf="produtoAtivo && !ncmsSugeridosPendentes">
      Todos os NCMs sugeridos já estão cadastrados.
    </p>
    <div
      class="suggestions-toolbar"
      *ngIf="produtoAtivo && ncmsSugeridosPendentes"
    >
      <label class="select-all">
        <input
          type="checkbox"
          [checked]="ncmsSelecionados().size === ncmsSugeridosPendentes"
          (change)="selecionarTodosNcms($any($event.target).checked)"
        />
        Selecionar todos os pendentes ({{ ncmsSugeridosPendentes }})
      </label>
      <app-button
        type="button"
        [text]="
          'Importar selecionados como rascunho (' +
          ncmsSelecionados().size +
          ')'
        "
        icon="pi-download"
        [disabled]="!ncmsSelecionados().size"
        [loading]="importandoNcms()"
        [fullWidth]="false"
        (click)="importarNcmsSelecionados()"
      ></app-button>
    </div>
    <div class="suggestions">
      <div
        class="suggestion"
        *ngFor="let sugestao of ncmsSugeridos"
        [class.registered]="sugestao.jaCadastrado"
      >
        <label class="check" *ngIf="produtoAtivo">
          <input
            type="checkbox"
            [disabled]="sugestao.jaCadastrado"
            [checked]="sugestao.jaCadastrado || ncmSelecionado(sugestao.ncm)"
            (change)="toggleNcm(sugestao, $any($event.target).checked)"
          />
        </label>
        <div class="info">
          <span class="code">{{ sugestao.ncmFormatado }}</span>
          <span class="description">{{ sugestao.descricao }}</span>
          <small>
            CNAE {{ sugestao.cnaes.join(", ") }}
            <ng-container *ngIf="sugestao.jaCadastrado">
              · já cadastrado
            </ng-container>
          </small>
        </div>
        <app-button
          type="button"
          [text]="sugestao.jaCadastrado ? 'Cadastrado' : 'Parametrizar agora'"
          [icon]="sugestao.jaCadastrado ? 'pi-check' : 'pi-pencil'"
          [disabled]="sugestao.jaCadastrado || !produtoAtivo"
          [backgroundColor]="
            sugestao.jaCadastrado ? 'var(--green-500)' : 'var(--slate-500)'
          "
          [fullWidth]="false"
          (click)="solicitarCadastroNcm(sugestao)"
        ></app-button>
      </div>
    </div>
  </app-section>
  <app-section
    *ngIf="cnpjLookup() && atividades.length"
    title="Atividades (CNAE) e pré-cadastro de serviços"
    description="Cada atividade da empresa na Receita Federal vira um serviço pré-cadastrado na aba NFS-e, vinculado ao CNAE e inativo, assim que o cadastro for salvo com a emissão de NFS-e habilitada. O contador completa o que falta (item da LC 116 quando não sugerido, alíquota do ISS, código de tributação do município, NBS, IBS/CBS) e ativa."
  >
    <p class="suggestions-hint" *ngIf="!nfseAtiva">
      Habilite a emissão de NFS-e e salve o cadastro para gerar os
      pré-cadastros.
    </p>
    <p class="suggestions-hint" *ngIf="nfseAtiva && !atividadesSemServico">
      Todas as atividades já têm serviço vinculado na aba NFS-e.
    </p>
    <p class="suggestions-hint" *ngIf="nfseAtiva && atividadesSemServico">
      {{ atividadesSemServico }} atividade(s) sem serviço vinculado: ao salvar,
      o pré-cadastro é criado automaticamente.
    </p>
    <div class="suggestions">
      <div
        class="suggestion"
        *ngFor="let atividade of atividades"
        [class.registered]="atividade.servicoCadastrado"
      >
        <div class="info">
          <span class="code">
            {{ atividade.codigoFormatado }}
            <span class="tag" *ngIf="atividade.principal">principal</span>
          </span>
          <span class="description">{{ atividade.descricao }}</span>
          <small>
            {{
              atividade.servicoCadastrado
                ? "Serviço vinculado na aba NFS-e"
                : "Sem serviço vinculado: será pré-cadastrado ao salvar"
            }}
          </small>
        </div>
        <span
          class="pi"
          [ngClass]="
            atividade.servicoCadastrado ? 'pi-check-circle' : 'pi-clock'
          "
        ></span>
      </div>
    </div>
  </app-section>
  <app-section
    title="Endereço"
    description="Informe o endereço principal da sua empresa."
    formGroupName="endereco"
  >
    <app-fields>
      <app-input
        label="CEP"
        mask="00.000-000"
        formControlName="cep"
      ></app-input>
      <app-select
        [options]="states()"
        formControlName="estado"
        label="Estado"
      ></app-select>
      <app-select
        *ngIf="cities().length"
        [options]="cities()"
        label="Cidade"
        formControlName="descricaoCidade"
      ></app-select>
      <app-input label="Bairro" formControlName="bairro"></app-input>
      <app-input
        label="Logradouro"
        formControlName="logradouro"
        [maxlength]="60"
      ></app-input>
      <app-select
        [options]="tipoLogradouroOptions"
        label="Tipo de logradouro"
        formControlName="tipoLogradouro"
      ></app-select>
      <app-input label="Número" formControlName="numero"></app-input>
      <app-input label="Complemento" formControlName="complemento"></app-input>
    </app-fields>
  </app-section>
  <app-section
    title="Emissão de NF-e"
    description="Informe a configuração padrão para emissão de notas fiscais de produto."
    formGroupName="nfe"
  >
    <app-fields>
      <app-select
        [options]="yesOrNot"
        formControlName="ativo"
        label="Habilitar emissão de NF-e"
      ></app-select>
      <ng-container formGroupName="config" *ngIf="!!nfe?.get('ativo')?.value">
        <ng-container formGroupName="email">
          <app-select
            [options]="yesOrNot"
            formControlName="envio"
            label="Envio automático de e-mails"
          ></app-select>
        </ng-container>
        <ng-container formGroupName="csrt">
          <app-input
            formControlName="id"
            label="CSRT ID"
            [maxlength]="20"
            hint="Preencha quando exigido pela SEFAZ do estado"
          ></app-input>
          <app-input
            formControlName="token"
            label="CSRT Token"
            hint="Obrigatório quando o CSRT ID estiver preenchido."
          ></app-input>
        </ng-container>
        <app-select
          [options]="yesOrNot"
          formControlName="producao"
          label="Emissão com valor fiscal"
        ></app-select>
        <!-- Numeração sempre automática (orientação do contador): o seletor
             foi removido; série/número só são informados na primeira
             configuração. -->
        <small class="automatic-numbering-hint">
          {{
            nfeAlterandoNumeracao()
              ? "Informe a série e o número da última NF-e emitida (inclusive em outra plataforma). Ao salvar, a próxima NF-e sai com o número seguinte."
              : nfeNumeracaoLocked
                ? "A numeração da NF-e é automática: o PlugNotas controla e avança sozinho a cada nota autorizada. Para continuar a numeração de outra plataforma, use “Alterar numeração”."
                : "A numeração da NF-e é automática: depois da primeira nota, o PlugNotas avança sozinho a cada NF-e autorizada."
          }}
        </small>
        <!-- Sem numeração no PlugNotas ainda (nenhuma NF-e configurada/emitida):
             série e número ficam abertos e o botão "Alterar numeração" só
             aparece depois de salvar. O aviso deixa isso explícito. -->
        <div class="numbering-warning" *ngIf="!nfeNumeracaoLocked">
          <i class="pi pi-exclamation-triangle"></i>
          <span>
            Ainda não há numeração de NF-e registrada para esta empresa. O
            número informado abaixo será o da
            <strong>primeira NF-e</strong> emitida por aqui. Se a empresa já
            emitia NF-e em outra plataforma, informe a mesma série e o número
            <strong>seguinte</strong> ao da última nota emitida lá. Depois de
            salvar, a numeração fica travada e só pode ser ajustada pelo botão
            “Alterar numeração”.
          </span>
        </div>
        <app-input
          formControlName="serie"
          label="Série da NF-e"
          [maxlength]="5"
          [hint]="
            nfeAlterandoNumeracao()
              ? 'Série em que a numeração continua (até 5 caracteres).'
              : nfeNumeracaoLocked
                ? 'Controlada pelo PlugNotas.'
                : 'Opcional; até 5 caracteres (padrão: 1).'
          "
        ></app-input>
        <app-input
          type="number"
          formControlName="numero"
          [label]="
            nfeNumeracaoLocked
              ? 'Numeração atual da NF-e'
              : 'Número inicial da NF-e'
          "
          [hint]="nfeNumeracaoLocked ? 'Controlada pelo PlugNotas.' : ''"
        ></app-input>
        <app-input
          *ngIf="nfeAlterandoNumeracao()"
          type="number"
          formControlName="ultimoNumeroEmitido"
          label="Número da última NF-e emitida"
          hint="A próxima NF-e sai com o número seguinte. Use 0 se nenhuma foi emitida nesta série."
        ></app-input>
        <div class="numbering-actions" *ngIf="nfeNumeracaoLocked">
          <app-button
            *ngIf="!nfeAlterandoNumeracao()"
            type="button"
            text="Alterar numeração"
            icon="pi-pencil"
            backgroundColor="var(--slate-500)"
            (click)="iniciarAlteracaoNumeracao('nfe')"
          ></app-button>
          <app-button
            *ngIf="nfeAlterandoNumeracao()"
            type="button"
            text="Cancelar alteração"
            icon="pi-times"
            backgroundColor="var(--orange-500)"
            (click)="cancelarAlteracaoNumeracao('nfe')"
          ></app-button>
        </div>
      </ng-container>
    </app-fields>
  </app-section>
  <app-section
    title="Emissão de NFC-e (Cupom Fiscal)"
    description="Nota Fiscal de Consumidor Eletrônica (modelo 65) para venda ao consumidor final, emitida a partir do orçamento fechado. Exige credenciamento da empresa na SEFAZ do estado para NFC-e, separado do da NF-e."
    formGroupName="nfce"
  >
    <app-fields>
      <app-select
        [options]="yesOrNot"
        formControlName="ativo"
        label="Habilitar emissão de NFC-e"
      ></app-select>
      <ng-container formGroupName="config" *ngIf="nfceAtiva">
        <ng-container formGroupName="email">
          <app-select
            [options]="yesOrNot"
            formControlName="envio"
            label="Envio automático de e-mails"
          ></app-select>
        </ng-container>
        <app-select
          [options]="yesOrNot"
          formControlName="producao"
          label="Emissão com valor fiscal"
        ></app-select>
        <app-select
          [options]="nfceQrCodeOptions"
          formControlName="versaoQrCode"
          label="Versão do QR Code"
        ></app-select>
        <small class="automatic-numbering-hint">
          {{
            nfceExigeCsc
              ? "QR Code versão 2: informe o CSC (Código de Segurança do Contribuinte) obtido no portal da SEFAZ do estado. Existe um CSC para homologação e outro para produção — use o do ambiente escolhido em “Emissão com valor fiscal”."
              : "QR Code versão 3 (NT 2025.001): a autenticidade do cupom é garantida pela assinatura digital no próprio QR Code, sem CSC. A adoção da versão 3 é decidida por cada estado — confirme com a SEFAZ da sua UF (ou com o contador) se ela já é aceita; se não, selecione a versão 2 e informe o CSC."
          }}
        </small>
        <ng-container formGroupName="sefaz" *ngIf="nfceExigeCsc">
          <app-input
            formControlName="idCodigoSegurancaContribuinte"
            label="ID do CSC"
            [maxlength]="6"
            hint="Identificador do CSC no portal da SEFAZ (ex.: 000001)."
            autocomplete="off"
          ></app-input>
          <!-- Segredo do contribuinte: campo tipo senha e sem autocompletar. -->
          <app-input
            type="password"
            formControlName="codigoSegurancaContribuinte"
            label="Código do CSC"
            [maxlength]="36"
            hint="Código alfanumérico fornecido pela SEFAZ. Nunca compartilhe."
            autocomplete="new-password"
          ></app-input>
        </ng-container>
        <!-- Numeração sempre automática; a série da NFC-e é independente da
             série da NF-e (modelos 65 e 55). -->
        <small class="automatic-numbering-hint">
          {{
            nfceAlterandoNumeracao()
              ? "Informe a série e o número da última NFC-e emitida (inclusive em outra plataforma). Ao salvar, a próxima NFC-e sai com o número seguinte."
              : nfceNumeracaoLocked
                ? "A numeração da NFC-e é automática: o PlugNotas controla e avança sozinho a cada cupom autorizado. Para continuar a numeração de outra plataforma, use “Alterar numeração”."
                : "A numeração da NFC-e é automática e independente da NF-e: depois do primeiro cupom, o PlugNotas avança sozinho a cada NFC-e autorizada."
          }}
        </small>
        <div class="numbering-warning" *ngIf="!nfceNumeracaoLocked">
          <i class="pi pi-exclamation-triangle"></i>
          <span>
            Ainda não há numeração de NFC-e registrada para esta empresa. O
            número informado abaixo será o da
            <strong>primeira NFC-e</strong> emitida por aqui. Se a empresa já
            emitia NFC-e em outra plataforma, informe a mesma série e o número
            <strong>seguinte</strong> ao do último cupom emitido lá. Depois de
            salvar, a numeração fica travada e só pode ser ajustada pelo botão
            “Alterar numeração”.
          </span>
        </div>
        <app-input
          formControlName="serie"
          label="Série da NFC-e"
          [maxlength]="5"
          [hint]="
            nfceAlterandoNumeracao()
              ? 'Série em que a numeração continua (até 5 caracteres).'
              : nfceNumeracaoLocked
                ? 'Controlada pelo PlugNotas.'
                : 'Opcional; até 5 caracteres (padrão: 1).'
          "
        ></app-input>
        <app-input
          type="number"
          formControlName="numero"
          [label]="
            nfceNumeracaoLocked
              ? 'Numeração atual da NFC-e'
              : 'Número inicial da NFC-e'
          "
          [hint]="nfceNumeracaoLocked ? 'Controlada pelo PlugNotas.' : ''"
        ></app-input>
        <app-input
          *ngIf="nfceAlterandoNumeracao()"
          type="number"
          formControlName="ultimoNumeroEmitido"
          label="Número da última NFC-e emitida"
          hint="A próxima NFC-e sai com o número seguinte. Use 0 se nenhuma foi emitida nesta série."
        ></app-input>
        <div class="numbering-actions" *ngIf="nfceNumeracaoLocked">
          <app-button
            *ngIf="!nfceAlterandoNumeracao()"
            type="button"
            text="Alterar numeração"
            icon="pi-pencil"
            backgroundColor="var(--slate-500)"
            (click)="iniciarAlteracaoNumeracao('nfce')"
          ></app-button>
          <app-button
            *ngIf="nfceAlterandoNumeracao()"
            type="button"
            text="Cancelar alteração"
            icon="pi-times"
            backgroundColor="var(--orange-500)"
            (click)="cancelarAlteracaoNumeracao('nfce')"
          ></app-button>
        </div>
      </ng-container>
    </app-fields>
  </app-section>
  <app-section
    title="Emissão de NFS-e"
    description="Informe a configuração padrão para emissão de notas fiscais de serviço."
    formGroupName="nfse"
  >
    <app-fields>
      <app-select
        [options]="yesOrNot"
        formControlName="ativo"
        label="Habilitar emissão de NFS-e"
      ></app-select>
      <ng-container formGroupName="config" *ngIf="!!nfse?.get('ativo')?.value">
        <ng-container formGroupName="email">
          <app-select
            [options]="yesOrNot"
            formControlName="envio"
            label="Envio automático de e-mails"
          ></app-select>
        </ng-container>
        <app-select
          [options]="yesOrNot"
          formControlName="producao"
          label="Emissão com valor fiscal"
        ></app-select>
        <ng-container formGroupName="rps">
          <!-- Numeração sempre automática (orientação do contador): o
               seletor foi removido; série/número só na primeira configuração. -->
          <small class="automatic-numbering-hint">
            {{
              nfseAlterandoNumeracao()
                ? "Informe a série e o número da última NFS-e (RPS) emitida (inclusive em outra plataforma). Ao salvar, a próxima sai com o número seguinte."
                : nfseNumeracaoLocked
                  ? "A numeração do RPS é automática: o PlugNotas controla e avança sozinho a cada nota autorizada. Para continuar a numeração de outra plataforma, use “Alterar numeração”."
                  : "A numeração do RPS é automática: depois da primeira nota, o PlugNotas avança sozinho a cada NFS-e autorizada."
            }}
          </small>
          <div class="numbering-warning" *ngIf="!nfseNumeracaoLocked">
            <i class="pi pi-exclamation-triangle"></i>
            <span>
              Ainda não há numeração de RPS registrada para esta empresa. O
              número informado abaixo será o da <strong>primeira NFS-e</strong>
              emitida por aqui. Se a empresa já emitia NFS-e em outra
              plataforma, informe a mesma série e o número
              <strong>seguinte</strong> ao do último RPS emitido lá. Depois de
              salvar, a numeração fica travada e só pode ser ajustada pelo botão
              “Alterar numeração”.
            </span>
          </div>
          <app-input type="number" formControlName="lote" label="Lote">
          </app-input>
          <app-input
            formControlName="serie"
            label="Série do RPS"
            [maxlength]="5"
            [hint]="
              nfseAlterandoNumeracao()
                ? 'Série em que a numeração continua (até 5 caracteres).'
                : nfseNumeracaoLocked
                  ? 'Controlada pelo PlugNotas.'
                  : 'Opcional; até 5 caracteres (padrão: 1).'
            "
          >
          </app-input>
          <app-input
            type="number"
            formControlName="numero"
            [label]="
              nfseNumeracaoLocked
                ? 'Numeração atual do RPS'
                : 'Número inicial do RPS'
            "
            [hint]="nfseNumeracaoLocked ? 'Controlada pelo PlugNotas.' : ''"
          >
          </app-input>
          <app-input
            *ngIf="nfseAlterandoNumeracao()"
            type="number"
            formControlName="ultimoNumeroEmitido"
            label="Número do último RPS emitido"
            hint="A próxima NFS-e sai com o número seguinte. Use 0 se nenhuma foi emitida nesta série."
          ></app-input>
          <div class="numbering-actions" *ngIf="nfseNumeracaoLocked">
            <app-button
              *ngIf="!nfseAlterandoNumeracao()"
              type="button"
              text="Alterar numeração"
              icon="pi-pencil"
              backgroundColor="var(--slate-500)"
              (click)="iniciarAlteracaoNumeracao('nfse')"
            ></app-button>
            <app-button
              *ngIf="nfseAlterandoNumeracao()"
              type="button"
              text="Cancelar alteração"
              icon="pi-times"
              backgroundColor="var(--orange-500)"
              (click)="cancelarAlteracaoNumeracao('nfse')"
            ></app-button>
          </div>
        </ng-container>
        <ng-container formGroupName="prefeitura">
          <!-- O PlugNotas valida login/senha da prefeitura por município e
               descarta o que a cidade não usa (ex.: cidades que autenticam só
               pelo certificado digital). Só exibimos o que o município utiliza;
               sem metadados, mostramos os dois campos. -->
          <small class="automatic-numbering-hint" *ngIf="prefeituraAuthHint">
            {{ prefeituraAuthHint }}
          </small>
          <!-- autocomplete desligado: o Chrome trata o par texto+senha como
               credencial do site e sobrescreve o login ao autopreencher. -->
          <app-input
            *ngIf="prefeituraUsaLogin"
            formControlName="login"
            label="Login prefeitura"
            autocomplete="off"
          >
          </app-input>
          <app-input
            *ngIf="prefeituraUsaSenha"
            type="password"
            formControlName="senha"
            label="Senha prefeitura"
            autocomplete="new-password"
          >
          </app-input>
        </ng-container>
      </ng-container>
    </app-fields>
  </app-section>
  <app-section
    title="Certificado digital"
    description="O envio do certificado digital é obrigatório quando a emissão de NF-e, NFC-e ou NFS-e estiver habilitada."
  >
    <app-file-upload
      (certificateData)="handleCertificateData($event)"
    ></app-file-upload>
    <small *ngIf="companyForm.get('certificado')?.errors?.['required']">
      Envio obrigatório
    </small>
    <div class="cert" *ngIf="cert()">
      <h2>Dados do certificado atual</h2>
      <p>
        <span> Situação: </span>
        <span class="value">
          {{ certStatusText }}
          <span [class.valid]="certValid" class="status"></span>
        </span>
      </p>
      <p *ngIf="cert()?.cadastro">
        <span> Cadastrado em: </span>
        <span class="value">
          {{ cert()?.cadastro | date: "dd/MM/YYYY" }} às
          {{ cert()?.cadastro | date: "HH:mm:ss" }}
        </span>
      </p>
      <p *ngIf="cert()?.vencimento">
        <span> Vence em: </span>
        <span class="value">
          {{ certFormattedDate }}
        </span>
      </p>
    </div>
  </app-section>
  <app-section
    title="Logotipo"
    description="Envie o logotipo JPEG da sua empresa para ser impresso nas notas fiscais."
  >
    <app-logo-upload (data)="uploadLogo.emit($event)"></app-logo-upload>
  </app-section>
  <div class="floating-submit">
    <app-button
      [disabled]="!companyForm.valid"
      [loading]="loading"
      type="submit"
      text="Salvar"
      icon="pi-save"
    ></app-button>
  </div>
</form>
